import { render, staticRenderFns } from "./AdminBaseReviewFreelancers.vue?vue&type=template&id=35f167f6"
import script from "./AdminBaseReviewFreelancers.vue?vue&type=script&lang=js"
export * from "./AdminBaseReviewFreelancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports